import {
  Button,
  SizableText,
  SmartLink,
  TextLink,
  XStack,
  YStack,
  colors,
  shadowStandard,
} from '@my/ui'
import { Lock } from '@tamagui/lucide-icons'

interface NoAccessProps {
  title: string
  description?: string
  hideSignUp?: boolean
  verifyEmail?: boolean
}

export const NoAccess = ({ title, description, verifyEmail, hideSignUp }: NoAccessProps) => {
  return (
    <YStack ai="center" p="$3.5" br="$3" bg="$white" $gtSm={{ p: '$6', ...shadowStandard }}>
      <YStack maxWidth={500} ai="center" jc="center" gap="$5">
        <YStack
          flexGrow={0}
          br={1000}
          p="$2.5"
          jc="center"
          ai="center"
          bg="$white"
          {...shadowStandard}
        >
          <Lock color={colors.primary} width={36} height={36} />
        </YStack>
        <SizableText textAlign="center" size="$6" color="$overlay11" fow="700">
          {title}
        </SizableText>
        {description && (
          <SizableText textAlign="center" size="$3" color="$overlay11">
            {description}
          </SizableText>
        )}
        {verifyEmail && (
          <XStack jc="center">
            <SmartLink
              Component={Button}
              href="/onboarding/student/university-email"
              theme="primary"
              flexBasis={286}
            >
              Verify email
            </SmartLink>
          </XStack>
        )}
        {!hideSignUp && (
          <YStack gap="$2" ai="center" jc="center">
            <SmartLink Component={Button} href="/sign-up" minWidth={250} theme="primary">
              Join now
            </SmartLink>
            <SizableText fow="400">
              Already have an account?{' '}
              <TextLink fow="600" href="/log-in">
                Log in
              </TextLink>
            </SizableText>
          </YStack>
        )}
      </YStack>
    </YStack>
  )
}
